export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'danger';

                            if (value === 'active') ClassName = `success`;
                            else if (value === 'invited') ClassName = `warning`;

                            return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
                        }
                    }
                },
                {
                    title: this.$t('name'),
                    type: 'link',
                    key: 'name',
                    modifier: (value, row) => {
                      return `container/${row.id}`;
                    }
            
                },
                {
                    title: this.$t('valid'),
                    type: 'text',
                    key: 'valid',
            
                },
                {
                    title: this.$t('usage'),
                    type: 'custom-html',
                    key: 'usage',
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'danger';

                            if (value === 'active') ClassName = `success`;
                            else if (value === 'invited') ClassName = `warning`;

                            return `<span class="badge badge-pill note-info text-success me-2">${value}% </span>`;
                        } else
                        if (value == 0) {
                            return `<span class="badge badge-pill note-info text-success me-2">0% </span>`;
                        }
                    }
                },
                {
                    title: this.$t('plan'),
                    type: 'text',
                    key: 'plan',
                },
            ],
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
    methods: {
        calculatePercentage(requests, bookedRequests) {
          if (requests === 0 || bookedRequests === 0) {
            return 0;
          }
    
          const percentage = ((bookedRequests / requests) * 100).toFixed(2);
    
          return percentage + '%';
        }
      }
}